import { combineReducers } from "redux";
import statesReducer from "./slices/statesSlice";
import purchasePriceReducer from "./slices/purchasePriceSlice";
import paymentProcessingReducer from "./slices/paymentProcessingSlice";

const paymentReducer = combineReducers({
  states: statesReducer,
  purchasePrice: purchasePriceReducer,
  processing: paymentProcessingReducer,
});

export default paymentReducer;
